import React from "react";
import Logo from "@assets/logos/logo.svg";
import { useMediaQuery } from "react-responsive";

import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/pagination";

import { Pagination, Autoplay } from "swiper/modules";

import styles from "./SignUpCarousel.module.css";

import Image1 from "@assets/carousel/login-1.png";
import Image2 from "@assets/carousel/login-2.png";
import Image3 from "@assets/carousel/login-3.png";
import Image4 from "@assets/carousel/login-4.png";
import Image5 from "@assets/carousel/login-5.png";
import Image1Horizontal from "@assets/carousel/login-1-horizontal.png";
import Image2Horizontal from "@assets/carousel/login-2-horizontal.png";
import Image3Horizontal from "@assets/carousel/login-3-horizontal.png";
import Image4Horizontal from "@assets/carousel/login-4-horizontal.png";
import Image5Horizontal from "@assets/carousel/login-5-horizontal.png";

const SignUpCarousel = () => {
  const isMobile = useMediaQuery({ query: "(max-height: 780px)" });

  // Use the condition to select the correct image set based on screen height
  const images = isMobile
    ? [
        Image1Horizontal,
        Image2Horizontal,
        Image3Horizontal,
        Image4Horizontal,
        Image5Horizontal,
      ]
    : [
        Image1,
        Image2,
        Image3,
        Image4,
        Image5,
      ];

  return (
    <div className="pt-[25px]">
      {/* Header Section */}
      <div className="flex justify-start items-center mb-6 ml-6">
        <img src={Logo} alt="Tylt" />
      </div>

      {/* Carousel Section */}
      <Swiper
        modules={[Pagination, Autoplay]}
        spaceBetween={20}
        slidesPerView={1.5}
        centeredSlides={true}
        loop={true}
        speed={800}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
          renderBullet: (index, className) => {
            return `<span class="${className} ${
              className.includes("swiper-pagination-bullet-active")
                ? styles.activeBullet
                : styles.inactiveBullet
            } rounded-full mx-1"></span>`;
          },
        }}
        className={styles.mySwiper}
      >
        {images.map((img, idx) => (
          <SwiperSlide key={idx}>
            <div className={`${styles.imageContainer}`}>
              <img
                src={img}
                alt={`Slide ${idx + 1}`}
                className={`object-cover rounded-lg ${styles.image}`}
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default SignUpCarousel;
